import React, { useEffect, useState, useRef } from 'react';
import { apiRequest } from '../../../service/apiRequest';
import {
  Table,
  Button,
  Flex,
  Breadcrumb,
  Form,
  message,
  Popconfirm,
  Space,
  Pagination,
  Switch,
  TableProps,
  Row,
  Col,
  Select,
  Input,
  Modal,
} from 'antd';
import { createStyles } from 'antd-style';
import {
  HomeOutlined, DeleteOutlined, EditOutlined, DownloadOutlined, UploadOutlined, TagOutlined, QrcodeOutlined, CheckCircleOutlined,
  StarOutlined, LineChartOutlined
} from '@ant-design/icons';
import { theme } from 'antd';
import ProductModal from './ProductModel';
import { showSuccess, showError } from '../../../components/errorHandler';

import ImportProductModal from './ImportProductModal';
import type { PopconfirmProps, TableColumnsType } from 'antd';
import { useCurrentModule } from '../../../hooks/useCurrentModule';


import { useSearchParams, useNavigate } from 'react-router-dom';
import CopyButton from '../../../components/copyButton';
import Barcode from '../../../components/Barcode';

import type {
  Pn,
  Categories,
  BrandNames,
  ProductInfo,
  GST,
  Qn,
  Qnum,
  Fts,
  Bc,
  Sc,
  Count,
  Composition,
  Finish,
  Width,
  Hc,
  Pf,
  FPs,
  SaleType,
  Pus,
  Carings,
  Size,
  It,
  Sn,
  ProductVariants,
  UnitType,
  Ledger,
} from '../../../types/CreateProductType';

interface BarcodeProps {
  value: string; // the product_code to encode
}
const useStyle = createStyles(({ css }) => ({
  customTable: css`
    .ant-table {
      &-container {
        .ant-table-body,
        .ant-table-content {
          scrollbar-width: thin;
          scrollbar-color: #eaeaea transparent;
        }
      }
    }
  `,
}));

interface Products {
  product_id: number;
  variant_id: number;
  product_name: string;
  pn_name: string;
  variant_code: string;
  brand_name: string;
  qn_name: string;
  qn_number: string;
  fp_pattern: string;
  sn_number: string;
  variant_unit: string;
  bc_name: string;
  product_code: string;
  product_price: number;
  product_status: number;
}
const Products: React.FC = () => {
  const hasFetchedRef = useRef(false);
  const navigate = useNavigate();
  const [products, setProducts] = useState<Products[]>([]);
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [initialValues, setInitialValues] = useState<Products | null>(null);
  const [isImportModalVisible, setIsImportModalVisible] = useState(false);
  const { styles } = useStyle();
  const [pagination, setPagination] = useState<{ current: number; pageSize: number; total: number }>({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const currentModule = useCurrentModule();

  const [filteredInfo, setFilteredInfo] = useState<Record<string, any>>({});
  const [sortedInfo, setSortedInfo] = useState<any>({});

  const [isUploadModalVisible, setIsUploadModalVisible] = useState(false);
  //  const [selectedRowKeys, setSelectedRowKeys] = useState([]);




  const [searchParams, setSearchParams] = useSearchParams('');

  const params = searchParams.get('params') || '';
  const productCode = searchParams.get('productCode') || '';
  const searchParamType = searchParams.get('searchParamType') || '';

  const [paramData, setparamData] = useState<any>(params);
  const [searchParamTypeData, setsearchParamTypeData] = useState<any>(searchParamType);
  const [productCodeData, setproductCodeData] = useState<any>(productCode);

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  // Add at the top of your component
  const [secondDropdownValue, setSecondDropdownValue] = useState<number | string | null>(null);


  const [gsts, setGSTs] = useState<GST[]>([]);
  const [selectedGST, setSelectedGST] = useState<number | null>(null);

  const [categories, setCategories] = useState<Categories[]>([]);
  const [selectedCategories, setSelectedCategories] = useState<number | null>(null);

  const [brandnames, setBrandNames] = useState<BrandNames[]>([]);
  const [selectedBrandNames, setSelectedBrandNames] = useState<number | null>(null);

  const [pns, setPns] = useState<Pn[]>([]);
  const [selectedPns, setSelectedPns] = useState<number | null>(null);

  const [selectedCompanyName, setSelectedCompanyName] = useState<number | null>(null);

  const [qns, setQns] = useState<Qn[]>([]);
  const [selectedQns, setSelectedQns] = useState<number | null>(null);


  const [qnums, setQnums] = useState<Qnum[]>([]);
  const [selectedQnums, setSelectedQnums] = useState<number | null>(null);


  const [fabrictypedata, setFabricTypeData] = useState<Fts[]>([]);
  const [selectedFts, setSelectedFts] = useState<number | null>(null);


  const [scs, setScs] = useState<Sc[]>([]);
  const [selectedScs, setSelectedScs] = useState<number | null>(null);


  const [compositions, setCompositions] = useState<Composition[]>([]);
  const [selectedComposition, setSelectedComposition] = useState<number | null>(null);


  const [finishes, setFinishes] = useState<Finish[]>([]);
  const [selectedFinish, setSelectedFinish] = useState<number | null>(null);


  const [fabricpatterndata, setFabricPatternData] = useState<FPs[]>([]);
  const [selectedFp, setSelectedFp] = useState<number | null>(null);


  const [sns, setSns] = useState<Sn[]>([]);
  const [selectedSn, setSelectedSn] = useState<number | null>(null);

  const [uts, setUts] = useState<UnitType[]>([]);

  const [lns, setLns] = useState<Ledger[]>([]);

  const cancel: PopconfirmProps['onCancel'] = (e) => {
    console.log(e);
    showError('Click on No');
  };

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();


  const fetchProduct = async (
    page = 1,
    limit = 10,
    productCode: string | null = null,
    params: string | null = null,
    paramsType: string | null = null
  ) => {
    console.log("paramData", paramData)
    try {
      const queryParamsObj: Record<string, string> = {
        page: String(page),
        limit: String(limit),
      };

      if (productCode) queryParamsObj.productCode = productCode;
      if (params) queryParamsObj.params = params;
      if (paramsType) queryParamsObj.paramsType = paramsType;

      const queryParams = new URLSearchParams(queryParamsObj);
      const url = `products?${queryParams.toString()}`;

      const response = await apiRequest<{
        data: Products[];
        page: number;
        limit: number;
        total: number;
      }>({
        method: 'get',
        url: url,
        data: {
          params: params,
          productCode: productCode,
          paramsType: paramsType
        }
      });
      console.log("data", response.data);
      setProducts(response.data);
      setPagination({
        current: response.page,
        pageSize: response.limit,
        total: response.total,
      });
    } catch {
      showError('Failed to fetch vouchers');
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (keys: React.Key[]) => setSelectedRowKeys(keys),
    hideSelectAll: false,
  };

  const onDownloadSticker = (record: Products) => {
    showSuccess(`Downloading sticker for ${record.product_name}`);
    // trigger download logic — using record.product_id
  };

  // const onUploadImage = (record: Products) => {
  //   showSuccess(`Uploading image for ${record.product_name}`);
  //   // open modal or navigate to upload page
  // };

  // const onBatchDownload = () => {
  //   if (!selectedRowKeys.length) {
  //     showError('Please select at least one product to download stickers.');
  //     return;
  //   }
  //   // batch download selected
  //   showSuccess(`Downloading stickers for ${selectedRowKeys.length} products`);
  // };

  const onBatchDownload = async () => {
    if (!selectedRowKeys.length) {
      message.error("Please select at least one product.");
      return;
    }

    try {
      const response = await apiRequest<Blob>({
        method: 'post',
        url: '/download-master-sticker',
        data: {
          variant_ids: selectedRowKeys.map(Number),
        },
        config: {
          responseType: 'blob', // ✅ Required to treat response as PDF Blob
        },
      });

      const blob = new Blob([response], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `master_stickers.pdf`);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      message.success("Download started.");
    } catch (error) {
      console.error("Master sticker download error:", error);
      message.error("Failed to download master stickers.");
    }
  };





  const onMeterDownload = async () => {
    if (!selectedRowKeys.length) {
      message.error("Please select at least one product.");
      return;
    }

    try {
      const response = await apiRequest<Blob>({
        method: 'post',
        url: '/download-meter-sticker',
        data: {
          variant_ids: selectedRowKeys.map(Number),
        },
        config: {
          responseType: 'blob',  // ✅ fix here
        },
      });

      const blob = new Blob([response], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `meter_stickers.pdf`);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      message.success("Download started.");
    } catch (error) {
      console.error("Meter sticker download error:", error);
      message.error("Failed to download meter stickers.");
    }
  };



  const onPieceDownload = async () => {
    if (!selectedRowKeys.length) {
      message.error("Please select at least one product.");
      return;
    }

    try {
      const response = await apiRequest<Blob>({
        method: 'post',
        url: '/download-piece-sticker',
        data: {
          variant_ids: selectedRowKeys.map(Number),
        },
        config: {
          responseType: 'blob',  // ✅ fix here
        },
      });

      const blob = new Blob([response], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `piece_stickers.pdf`);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      message.success("Download started.");
    } catch (error) {
      console.error("Piece sticker download error:", error);
      message.error("Failed to download piece stickers.");
    }
  };


  const onButtonDownload = async () => {
    if (!selectedRowKeys.length) {
      message.error("Please select at least one product.");
      return;
    }

    try {
      const response = await apiRequest<Blob>({
        method: 'post',
        url: '/download-button-sticker',
        data: {
          variant_ids: selectedRowKeys.map(Number),
        },
        config: {
          responseType: 'blob',  // ✅ fix here
        },
      });

      const blob = new Blob([response], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `button_stickers.pdf`);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      message.success("Download started.");
    } catch (error) {
      console.error("Button sticker download error:", error);
      message.error("Failed to download button stickers.");
    }
  };



  const onJewelleryDownload = async () => {
    if (!selectedRowKeys.length) {
      message.error("Please select at least one product.");
      return;
    }

    try {
      const response = await apiRequest<Blob>({
        method: 'post',
        url: '/download-jewellery-sticker',
        data: {
          variant_ids: selectedRowKeys.map(Number),
        },
        config: {
          responseType: 'blob',  // ✅ fix here
        },
      });

      const blob = new Blob([response], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `jewellery_stickers.pdf`);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      message.success("Download started.");
    } catch (error) {
      console.error("jewellery sticker download error:", error);
      message.error("Failed to download jewellery stickers.");
    }
  };




  const onBatchUpload = () => {
    // if (!selectedRowKeys.length) {
    //   showError('Please select at least one product to upload images.');
    //   return;
    // }
    // showSuccess(`Preparing to upload images for ${selectedRowKeys.length} products`);
    setIsUploadModalVisible(true);
    // maybe open another modal
  };

  useEffect(() => {
    fetchProduct(pagination.current, pagination.pageSize, productCodeData, paramData, searchParamTypeData);
  }, [searchParams]);

  const handleEditClick = (record: Products) => {
    navigate(`/create-products/${record.product_id}`);
  };

  const handleCreate = () => {
    fetchProduct(pagination.current, pagination.pageSize, productCodeData, paramData, searchParamTypeData);
  };

  const showCreateModal = () => {
    setIsEditMode(false);
    setInitialValues(null);
    setIsModalVisible(true);
  };

  const hideCreateModal = () => {
    setIsModalVisible(false);
    setIsEditMode(false);
    setInitialValues(null);
  };

  const handleDelete = async (product_id: number) => {
    try {
      await apiRequest({
        method: 'delete',
        url: `/delete-product/${product_id}`,
      });
      showSuccess('Product deleted');
      fetchProduct(pagination.current, pagination.pageSize, productCodeData, paramData, searchParamTypeData);
    } catch {
      showError('Failed to delete Product');
    }
  };

  const handleStatusToggle = async (productId: number) => {
    setProducts((prev) =>
      prev.map((item) =>
        item.product_id === productId
          ? { ...item, product_status: item.product_status === 1 ? 0 : 1 }
          : item
      )
    );

    try {
      await apiRequest({
        method: 'put',
        url: `/update-status-product/${productId}`,
      });
      showSuccess('Product status updated');
    } catch (error) {
      showError('Failed to update status');
      setProducts((prev) =>
        prev.map((item) =>
          item.product_id === productId
            ? { ...item, product_status: item.product_status === 1 ? 0 : 1 }
            : item
        )
      );
    }
  };

  const handleTableChange: TableProps<Products>['onChange'] = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };


  const handleOk = () => {
    // handle confirm action
    setIsUploadModalVisible(false);
  };

  const handleCancel = () => {
    setIsUploadModalVisible(false);
  };

  const fetchAllDataSequentially = async () => {
    try {
      const categoriesData = await apiRequest<Categories[]>({ method: 'get', url: `category?status=1` });
      setCategories(categoriesData);

      const brandNamesData = await apiRequest<BrandNames[]>({ method: 'get', url: `brand?status=1` });
      setBrandNames(brandNamesData);

      const pnsData = await apiRequest<Pn[]>({ method: 'get', url: `product-names?status=1` });
      setPns(pnsData);

      const qnsData = await apiRequest<Qn[]>({ method: 'get', url: `quality-names?status=1` });
      setQns(qnsData);

      const qnumsData = await apiRequest<Qnum[]>({ method: 'get', url: `quality-numbers?status=1` });
      setQnums(qnumsData);

      const ftData = await apiRequest<Fts[]>({ method: 'get', url: `fabric-types?status=1` });
      setFabricTypeData(ftData);

      const compositionData = await apiRequest<Composition[]>({ method: 'get', url: `compositions?status=1` });
      setCompositions(compositionData);

      const finishData = await apiRequest<Finish[]>({ method: 'get', url: `finishes?status=1` });
      setFinishes(finishData);

      const fpData = await apiRequest<FPs[]>({ method: 'get', url: `fabric-patterns?status=1` });
      setFabricPatternData(fpData);

      const snData = await apiRequest<Sn[]>({ method: 'get', url: `shade-numbers?status=1` });
      setSns(snData);

      const lnData = await apiRequest<{ ledgers: Ledger[] }>({ method: 'get', url: `h-ledger-data?status=1` });
      setLns(lnData.ledgers || []);

      const utData = await apiRequest<UnitType[]>({ method: 'get', url: `unit-types?status=1` });
      setUts(utData);

    } catch (error) {
      showError('Failed to fetch some data');
      console.error(error);
    }
  };

  useEffect(() => {
    if (!hasFetchedRef.current) {
      fetchAllDataSequentially();
      hasFetchedRef.current = true;
    }
  }, []);

  const typeDataMap: Record<string, any[]> = {
    categories: categories,
    brandname: brandnames,
    pns: pns,
    qns: qns,
    qnums: qnums,
    fabrictypedata: fabrictypedata,
    fabricpatterndata: fabricpatterndata,
    subfabricpattern: scs,
    sns: sns,
    compositions: compositions,
    finishes: finishes,
    lns: lns,
    variantcode: [],
    uts: uts,
  };




  const columns: TableColumnsType<Products> = [
    {
      title: 'S No.',
      key: 'variant_id',
      fixed: 'left',
      render: (_, __, index) => (
        <span>{index + 1}</span>
      ),
    },
    {
      title: 'Created On',
      dataIndex: 'product_created_on',
      key: 'product_created_on',
      render: (value) => {
        const formattedDate = value
          ? new Date(value).toLocaleDateString('en-IN', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          })
          : 'N/A';
        return <span>{formattedDate}</span>;
      },
    },
    {
      title: 'Item Name',
      dataIndex: 'pn_name',
      key: 'pn_name',
      filters: Array.from(new Set(products.map((p) => p.pn_name))).map((name) => ({
        text: name,
        value: name,
      })),
      filterSearch: true,
      filteredValue: filteredInfo.pn_name || null,
      onFilter: (value, record) => record.pn_name.includes(value as string),
      sorter: (a, b) => a.pn_name.localeCompare(b.pn_name),
      sortOrder: sortedInfo.columnKey === 'pn_name' ? sortedInfo.order : null,
      sortDirections: ['ascend', 'descend'],
      ellipsis: true,
    },
    {
      title: 'Variant Code',
      dataIndex: 'variant_code',
      key: 'variant_code',
      render: (_, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span>{record.variant_code || 'N/A'}</span>
          {record.variant_code && <CopyButton textToCopy={record.variant_code} />}
        </div>
      ),
    },
    {
      title: 'Brand',
      dataIndex: 'brand_name',
      key: 'brand_name',
      render: (_, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span>{record.brand_name || 'N/A'}</span>
          {record.brand_name && <CopyButton textToCopy={record.brand_name} />}
        </div>
      ),
    },
    {
      title: 'QL Name',
      dataIndex: 'qn_name',
      key: 'qn_name',
      render: (_, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span>{record.qn_name || 'N/A'}</span>
          {record.qn_name && <CopyButton textToCopy={record.qn_name} />}
        </div>
      ),
    },
    {
      title: 'QL No.',
      dataIndex: 'qlno_name',
      key: 'qn_number',
      render: (_, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span>{record.qn_number || 'N/A'}</span>
          {record.qn_number && <CopyButton textToCopy={record.qn_number} />}
        </div>
      ),
    },
    {
      title: 'Fab Pattern',
      dataIndex: 'fp_pattern',
      key: 'fp_pattern',
      render: (_, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span>{record.fp_pattern || 'N/A'}</span>
          {record.fp_pattern && <CopyButton textToCopy={record.fp_pattern} />}
        </div>
      ),
    },
    {
      title: 'Shade',
      dataIndex: 'sn_number',
      key: 'sn_number',
      render: (_, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span>{record.sn_number || 'N/A'}</span>
          {record.sn_number && <CopyButton textToCopy={record.sn_number} />}
        </div>
      ),
    },
    {
      title: 'Unit',
      dataIndex: 'variant_unit',
      key: 'variant_unit',
      render: (_, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span>{record.variant_unit || 'N/A'}</span>
          {record.variant_unit && <CopyButton textToCopy={record.variant_unit} />}
        </div>
      ),
    },
    {
      title: 'Color',
      dataIndex: 'bc_name',
      key: 'bc_name',
      render: (_, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <span>{record.bc_name || 'N/A'}</span>
          {record.bc_name && <CopyButton textToCopy={record.bc_name} />}
        </div>
      ),
    },
  ];


  // Conditionally add action column
  if (currentModule?.right_edit === 'Y' || currentModule?.right_delete === 'Y') {
    columns.push({
      title: 'Action',
      width: 200,
      fixed: 'right',
      render: (_: any, record: Products) => (
        <Space size="middle">
          {currentModule?.right_edit === 'Y' && (
            <>
              <Switch
                checkedChildren="Active"
                unCheckedChildren="Inactive"
                checked={!!record.product_status}
                onChange={() => handleStatusToggle(record.variant_id)}
              />
              <Button onClick={() => handleEditClick(record)} className="px-8">
                <EditOutlined />
              </Button>
            </>
          )}
          {currentModule?.right_delete === 'Y' && (
            <Popconfirm
              title="Delete this product?"
              onConfirm={() => handleDelete(record.variant_id)}
              onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button danger className="px-8">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          )}
        </Space>
      ),
    });
  }

  const handleImportSuccess = () => {
    fetchProduct();
  };

  return (
    <>
      <Space
        style={{
          display: 'flex',
          marginBottom: 16,
          alignItems: 'center',
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <Breadcrumb
          style={{ display: 'inline-block', margin: 0 }}
          items={[
            {
              href: '/',
              title: <HomeOutlined />,
            },
            {
              title: 'View Products',
            },
          ]}
        />
        <Flex gap="small">
          {currentModule?.right_add === 'Y' && (
            <Flex gap="small">
              <Button type="primary" onClick={() => navigate('/create-products')}>
                Add Product
              </Button>
            </Flex>
          )}
          {currentModule?.right_import === 'Y' && (
            <Flex gap="small">
              <Button type="primary" onClick={() => setIsImportModalVisible(true)}>
                Import Product
              </Button>
            </Flex>
          )}
        </Flex>
      </Space>
      <Space
        style={{
          display: 'flex',
          marginBottom: 16,
          alignItems: 'center',
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <Form form={form} layout="vertical">
          <Flex gap="small">
            <Form.Item
              name="searchParamTypeData"
              rules={[{ required: true, message: 'Please select a type' }]}
              style={{ minWidth: 200 }}
            >
              <Select
                placeholder="Select Type"
                value={searchParamTypeData}
                onChange={(val) => {
                  setsearchParamTypeData(val);       // set selected type
                  setSecondDropdownValue(null);      // reset second dropdown
                }}
                showSearch
                filterOption={(input, option) =>
                  typeof option?.label === "string" &&
                  option.label.toLowerCase().includes(input.toLowerCase())
                }
                options={[
                  { label: 'Category', value: 'categories' },
                  { label: 'Brand', value: 'brandname' },
                  { label: 'Product Name', value: 'pns' },
                  { label: 'Ql. Name', value: 'qns' },
                  { label: 'Ql. No.', value: 'qnums' },
                  { label: 'Fabric Type', value: 'fabrictypedata' },
                  { label: 'Fabric Pattern', value: 'fabricpatterndata' },
                  { label: 'Sub Fabric', value: 'subfabricpattern' },
                  { label: 'Shade No.', value: 'sns' },
                  { label: 'Compositions', value: 'compositions' },
                  { label: 'Finish', value: 'finishes' },
                  { label: 'Supplier Name', value: 'lns' },
                  { label: 'Variant Code', value: 'variantcode' },
                  { label: 'Unit Type', value: 'uts' },
                ]}
                style={{ width: 200 }}
              />
            </Form.Item>
            {/* Second dropdown: dynamic options based on first dropdown */}
            {searchParamTypeData != 'variantcode' && (
              < Form.Item style={{ minWidth: 200 }}>
                <Select
                  placeholder={`Select ${searchParamTypeData || 'value'}`}
                  value={secondDropdownValue}
                  onChange={(val) => {
                    setSecondDropdownValue(val);
                    setparamData(val);
                    // 🔥 Call API using selected category (or brand, etc.)
                    fetchProduct(
                      1,
                      pagination.pageSize,
                      productCodeData,
                      String(val),                     // selected category_id
                      searchParamTypeData      // "categories"
                    );
                  }}
                  showSearch
                  filterOption={(input, option) =>
                    typeof option?.label === "string" &&
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  options={
                    // searchParamTypeData
                    //   ? (typeDataMap[searchParamTypeData] || []).map((item) => {
                    searchParamTypeData && Array.isArray(typeDataMap[searchParamTypeData])
                      ? typeDataMap[searchParamTypeData].map((item) => {
                        let label = '';
                        let value: number | string = '';

                        switch (searchParamTypeData) {
                          case 'categories':
                            label = item.category_name;
                            value = item.category_id;
                            break;
                          case 'brandname':
                            label = item.brand_name;
                            value = item.brand_id;
                            break;
                          case 'pns':
                            label = item.pn_name;
                            value = item.pn_id;
                            break;
                          case 'qns':
                            label = item.qn_name;
                            value = item.qn_id;
                            break;
                          case 'qnums':
                            label = item.qn_number;
                            value = item.qn_id;
                            break;
                          case 'fabrictypedata':
                            label = item.ft_name;
                            value = item.ft_id;
                            break;
                          case 'fabricpatterndata':
                            label = item.fp_pattern;
                            value = item.fp_id;
                            break;
                          case 'subfabricpattern':
                            label = item.fp_pattern;
                            value = item.fp_id;
                            break;
                          case 'sns':
                            label = item.sn_number;
                            value = item.sn_id;
                            break;
                          case 'compositions':
                            label = item.composition_name;
                            value = item.composition_id;
                            break;
                          case 'finishes':
                            label = item.finish_name;
                            value = item.finish_id;
                            break;
                          case 'lns':
                            label = `${item.ledger_first_name} ${item.ledger_last_name}`;
                            value = item.ledger_id;
                            break;
                          case 'variantcode':
                            label = item.variant_code;
                            value = item.variant_id;
                            break;
                          case 'uts':
                            label = item.ut_name;
                            value = item.ut_id;
                            break;
                          default:
                            break;
                        }

                        return { label, value };
                      })
                      : [] // empty if no type selected
                  }
                  style={{ width: 200 }}
                />
              </Form.Item>
            )}
            {searchParamTypeData === 'variantcode' && (
              <Form.Item style={{ marginBottom: 0 }}>
                <Input
                  placeholder="Search product variant..."
                  value={paramData}
                  onChange={(e) => {
                    const val = e.target.value;
                    setparamData(val);
                    fetchProduct(
                      1,
                      pagination.pageSize,
                      productCodeData,
                      val,
                      searchParamTypeData
                    );
                  }}
                  allowClear
                />
              </Form.Item>
            )}
          </Flex>
        </Form>
      </Space >

      <Row gutter={[16, 16]}>
        <Col
          xs={24}   // full width on mobile
          sm={24}   // full width on small screens
          md={4}    // 4 cols width on medium+
          xl={2}
          xxl={2}
          style={{
            display: 'flex', alignItems: 'start', justifyContent: 'center', justifyItems: 'center', padding: '0'
          }}
        >
          <Space
            direction="vertical"
            size="middle"
            style={{ width: '100%', alignItems: 'center' }}
          >

            <Button
              type="primary"
              size="large"
              disabled={!selectedRowKeys.length}
              onClick={onBatchDownload}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                height: 80,
                width: 100,
                padding: 8,  // padding around whole button
              }}
            >
              <QrcodeOutlined style={{ fontSize: 20 }} />
              <div style={{
                textAlign: 'center',
                fontSize: 14,
                lineHeight: 1.2,
                paddingTop: 4, // try padding only top or bottom inside text div
                paddingBottom: 4,
              }}>
                Master<br />Sticker
              </div>
            </Button>


            <Button
              type="primary"
              size="large"
              disabled={!selectedRowKeys.length}
              onClick={onMeterDownload}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                height: 80,
                width: 100,
                padding: 8,  // padding around whole button
              }}
            >
              <LineChartOutlined style={{ fontSize: 20 }} />
              <div style={{
                textAlign: 'center',
                fontSize: 14,
                lineHeight: 1.2,
                paddingTop: 4, // try padding only top or bottom inside text div
                paddingBottom: 4,
              }}>
                Meter<br />Sticker
              </div>
            </Button>

            {/* <Button
              type="default"
              block
              disabled={!selectedRowKeys.length}
              icon={<UploadOutlined />}
              onClick={onBatchUpload}
            >
              Upload Images
            </Button> */}
            {/* <Button
              type="primary"
              size="large"
              disabled={!selectedRowKeys.length}
              onClick={onBatchUpload}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                height: 80,
                width: 100,
                padding: 8,
              }}
            >
              <UploadOutlined style={{ fontSize: 24, marginBottom: 4 }} />
              <div style={{ textAlign: 'center', fontSize: 12, lineHeight: 1.2 }}>
                Upload
                <br />
                Images
              </div>
            </Button> */}


            <Button
              type="primary"
              size="large"
              disabled={!selectedRowKeys.length}
              onClick={onPieceDownload}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                height: 80,
                width: 100,
                padding: 8,
              }}
            >
              <TagOutlined style={{ fontSize: 24, marginBottom: 4 }} />
              <div style={{ textAlign: 'center', fontSize: 12, lineHeight: 1.2 }}>
                Piece
                <br />
                Sticker
              </div>
            </Button>

            <Button
              type="primary"
              size="large"
              disabled={!selectedRowKeys.length}
              onClick={onButtonDownload}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                height: 80,
                width: 100,
                padding: 8,
              }}
            >
              <CheckCircleOutlined style={{ fontSize: 24, marginBottom: 4 }} />
              <div style={{ textAlign: 'center', fontSize: 12, lineHeight: 1.2 }}>
                Button
                <br />
                Sticker
              </div>
            </Button>

            <Button
              type="primary"
              size="large"
              disabled={!selectedRowKeys.length}
              onClick={onJewelleryDownload}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                height: 80,
                width: 100,
                padding: 8,
              }}
            >
              <StarOutlined style={{ fontSize: 24, marginBottom: 4 }} />
              <div style={{ textAlign: 'center', fontSize: 12, lineHeight: 1.2 }}>
                Jewellery
                <br />
                Sticker
              </div>
            </Button>
          </Space>
        </Col>

        <Col xs={24} sm={24} md={20} xl={22} xxl={22} >
          <div
            style={{
              minHeight: 360,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            <Table<Products>
              tableLayout="auto"
              rowKey="variant_id"
              rowSelection={{
                selectedRowKeys,
                onChange: setSelectedRowKeys,
                type: 'checkbox',
                columnWidth: 40,
              }}
              className={`${styles.customTable} scrollable-table`}
              columns={columns}
              onChange={handleTableChange}
              // dataSource={products.slice(
              //   (pagination.current - 1) * pagination.pageSize,
              //   pagination.current * pagination.pageSize
              // )}
              dataSource={products}
              bordered
              pagination={false}
              // scroll={{ y: 37 * 15 }}
              scroll={{ x: 1900, y: 37 * 15 }}
              locale={{ emptyText: 'No product found' }}
              footer={() => (
                <Flex justify="space-between">
                  {/* <span>
                    Showing {(pagination.current - 1) * pagination.pageSize + 1}–
                    {Math.min(pagination.current * pagination.pageSize, products.length)} of{' '}
                    {products.length}
                  </span> */}
                  <span>
                    Showing {(pagination.current - 1) * pagination.pageSize + 1} –{' '}
                    {(pagination.current - 1) * pagination.pageSize + products.length} of {pagination.total}
                  </span>
                  <Pagination
                    {...pagination}
                    current={pagination.current}
                    pageSize={pagination.pageSize}
                    total={pagination.total}
                    showSizeChanger
                    pageSizeOptions={['10', '20', '50', '100']}
                    onChange={(page, pageSize) => {
                      setPagination((prev) => ({ ...prev, current: page, pageSize }));
                      fetchProduct(page, pageSize, productCodeData, paramData, searchParamTypeData);
                    }}
                  />

                </Flex>
              )}
            />
          </div>
        </Col>
        <ImportProductModal
          visible={isImportModalVisible}
          onClose={() => setIsImportModalVisible(false)}
          onSuccess={handleImportSuccess}
        />
      </Row>

    </>
  );
};

export default Products;